import React from 'react';
import { Link } from 'react-router-dom';
import { IProps } from './types';
import _ from 'lodash';
import { Code } from 'bff/models/info';
import { RouterSettings } from 'constants/models/routerSettings';
import commonService from 'utils/commonService';

const SurveyCompleted: React.FC<IProps> = (props) => {
  /**
   * @description 建立頁面內容
  */
  const handleCreateContent = () => {
    let title;
    const contents = new Array(0);
    _.forEach(props.carSurveyDoneCode, (code:Code, index:number) => {
      if (index === 0) {
        title = <div className="survey-page__title">{code.CODE_VALUE}</div>;

        return;
      }

      contents.push(<div className="survey-page__paragraph" key={index}>{commonService.htmlParser(code.CODE_VALUE)}</div>);
    });

    return (
      <>
        {title}
        {contents}
      </>
    );
  };

  return (
    <div className="survey-page">
      {
        handleCreateContent()
      }
      <div className="survey-page__controls">
        <Link to={RouterSettings.Home} className="survey-page__btn--link">回首頁</Link>
      </div>
    </div>
  );
};

export default SurveyCompleted;
